import React, { useEffect } from 'react'
import { useState } from 'react'
import kotakImg from '../Images/arrow.svg'
import Ruppee from '../Images/Rupee.svg'
import Kotak from '../Images/kotak.svg'
import HDFC from "../Images/hdfc.svg"
import * as Yup from "yup";
import { form, Formik, ErrorMessage, useFormik } from 'formik';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from "react-select";
import { CircularProgress, Grow, Modal } from '@mui/material';
import { Digimandate } from './Digio'
import Digio from '../Images/digio.svg'
import Loader from './Loader'
import Lang from '../Images/lang.svg'
import { useDropzone } from "react-dropzone";
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { setBase64Data, setLoggedIn, setMessage, setOtpTriggered } from './MandateSlice'
import download from '../Images/download.svg'
import upload from '../Images/Upload.svg'
import pdf from '../Images/pdf.svg'
import close from '../Images/close.svg'
import HtmlPageRenderer from './HtmlPageRenderer'
import HdfcRedirector from './HtmlPageRenderer'

const customStyles = {
    option: (provided) => ({
        ...provided,
        padding: "14px 16px",
        borderRadius: "10px",
    }),
};

function Kotakmandate() {
    const { mandateData, base64Data, partner } = useSelector((state) => state.mandateInfo);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const { mandateID } = useSelector((state) => state.mandateInfo);
    // const source_Sys = sessionStorage.getItem('vertical')
    // const amount = sessionStorage.getItem('amount')
    // const leadId = sessionStorage.getItem('leadId')
    const { state } = useLocation();
    const [disable, setDisable] = useState(false)
    const { mandateIdType } = useSelector((state) => state.mandateInfo);
    const [hdfcString, setHdfcString] = useState('')
    // const mandate = sessionStorage.getItem('mandate')
    const [isOpen, setisOpen] = useState(false)
    const [showErr, setShowErr] = useState(false)
    const [ifscLoading, setIfscLoading] = useState(false);
    const [isLoadingComp, setIsLoadingComp] = useState(false);
    const [bankName, setBankName] = useState("");
    const [branchorcityName, setBranchorcityName] = useState("");
    const [filteredResult, setFilteredResult] = useState(null);
    const [options, setOptions] = useState([]);
    const [fieldValue, setFieldValue] = useState('')
    const [uploadStatus, setUploadStatus] = useState(false);// 1. Add state at the top of the component
    const [hdfcHtmlString, setHdfcHtmlString] = useState(null)
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false)
    const [dmsId, setDmsId] = useState(false)
    const [eNachRequestdata, seteNachRequestdata] = useState()
    const [eNachResponsedata, seteNachResponsedata] = useState()
    const handleChangeBank = (e) => {
        setBankName(e.value);
    };
    const initialValue = { accountNo: mandateData?.Account_number ? mandateData?.Account_number : '', Source_Sys: mandateData?.Source_Sys ? mandateData?.Source_Sys : '', ifscCode: mandateData?.Branch_Code ? mandateData?.Branch_Code : fieldValue, mobileNo: mandateData?.Phone ? mandateData?.Phone : '', email: mandateData?.Email ? mandateData?.Email : '', amount: mandateData?.Collection_Amount ? mandateData?.Collection_Amount : '', name: mandateData?.Name ? mandateData?.Name : '', accType: mandateData?.Account_type ? mandateData?.Account_type : '', mandateIdType: mandateIdType, mandateOption: mandateData?.mandateOption ?? "" }
    const schema = Yup.object().shape({
        accountNo: Yup.number()
            .required("This field is required"),
        // .matches(/^[0-9]{9,18}$/, "Please enter valid Account Number"),
        ifscCode: Yup.string()
            .required("This field is required")
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Please enter valid IFSC Code"),
        mobileNo: Yup.string()
            .required('Mobile number is required')
            .test("Mobile number length", "Must be exactly 10 numbers", (val) => {
                if (!val) return false;
                if (val.toString().length < 10) {
                    return false;
                }
                return true;
            }),
        email: Yup.string()
            .when('Source_Sys', {
                is: (val) => ((val === 'D2C-PVCV' || val === 'CSEL') ? false : true),
                then: () => Yup.string().matches(
                    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                    'Invalid email address'
                ).required('Email ID Required')
            }),
        accType: Yup.string()
            .test("Please select an option", "Please select an option", (val) => {
                if (val === undefined || val === '') {
                    return false;
                }
                return true;
            }),
        name: Yup.string().typeError('Invalid name').nullable().transform((value, originalValue) =>
            originalValue.trim() === '' ? null : value
        )
            .required('Name is required')
            .matches(/([A-z][\s\.]|[A-z])+/, "Enter a valid name")
            .test("Name Length", "Must be minimun 3 characters", (val) => {
                if (val === undefined || val === '') {
                    return false;
                }
                if (val.length < 3) {
                    return false;
                }
                return true;
            }),
        amount: Yup.string()
            .required('Amount is required')
            .test('Amount Length', 'The minimum and maximum limit of amount is 1', (val) => {
                if (val === undefined || val === '') {
                    return false;
                }
                if (val.length < 1) {
                    return false;
                }
                return true;
            }),
        mandateOption: Yup.string()
            .when('mandateIdType', {
                is: (val) => ((val === 'hdfc-e-mandate')),
                then: () => Yup.string().required('Mandate Option is Required')
            }),
    })
    const formik = useFormik({
        initialValues: initialValue,
        validationSchema: schema,
        onSubmit: async (values) => { updateMandate(values) }
    })
    console.log(formik.errors, formik?.touched)
    useEffect(() => {
        axios({
            url: process.env.REACT_APP_BANK_API,
            // url:"https://ustgapig.chola.murugappa.com/cselmandateapi/1.0.0/bank_initial",
            headers: { Authorization: process.env.REACT_APP_API_KEY }
        })
            .then((res) => {
                // let val = bankNames;
                let val = res?.data?.result;
                let FormatedOptions = val?.map((item) => {
                    return {
                        name: item,
                        value: item,
                    };
                });
                setOptions(FormatedOptions);
            })
            .catch((e) => {
                setLoader(false)
                setShowErr(e?.message)
            });
    }, []);
    // const callIfsc = async (ifsc) => {
    //     try {
    //       setIfscLoading(true);
    //       await dispatch(
    //         verifyIfsc({
    //           lead_id,
    //           account_no: values?.bankAccNo,
    //           ifsc: ifsc.toUpperCase(),
    //         })
    //       ).unwrap();
    //       Formik.setFieldValue("ifscVerified", true);
    //     } catch (error) {
    //       // do nothing
    //     }
    //     setIfscLoading(false);
    //   };
    const onSelectingIFSC = (ifsc) => {
        formik.setFieldValue("ifscCode", ifsc);
        // callIfsc(ifsc);
        setFilteredResult(null);
        setBranchorcityName("");
        setBankName("");
        setisOpen(false);
    };
    const downloadPdf = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = "data:image/png;base64," + base64Data;
        downloadLink.download = "convertedPDFFile.pdf";
        downloadLink.click();
    }
    const serachIfscData = async () => {
        try {
            setLoader(true);
            const response = await axios({
                url: process.env.REACT_APP_IFSC_API + `/bank_details?bank_name=${bankName}&search=${branchorcityName}`,
                method: "GET",
                headers: { "Access-Control-Allow-Origin": "*", Authorization: process.env.REACT_APP_API_KEY }
            });
            setLoader(false);
            return setFilteredResult(response.data.result);
        } catch (e) {
            setLoader(false);
        }
    };

    const onDrop = (acceptedFiles) => {
        const convertedFiles = acceptedFiles.map((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            return new Promise((resolve, reject) => {
                reader.onload = () => resolve([file.name, reader.result.split(";base64,").pop()]);
                reader.onerror = reject;
            });
        });

        Promise.all(convertedFiles).then((base64Strings) => {
            handleUpload(base64Strings);
            setUploadStatus(true);
        });
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, acceptedFiles: "pdf,image/jpeg,image/png" });

    const handleUpload = async (document) => {
        console.log(document)
        setLoader(true);
        let data = {
            "unique_id": mandateData?.unique_id,
            "ScannedImage": document[0][1]
        }
        await axios({
            url: process.env.REACT_APP_API_COMMON + '/kotak/uploadpmandate',
            data: data,
            method: 'POST',
            headers: { Authorization: process.env.REACT_APP_API_KEY }
        }).then(obj => {
            console.log(obj)
            setLoader(false);
            if (obj?.data?.Status) {
                window.location.assign(obj?.data?.redirect_url)
            }
        })
    }

    const updateMandate = (values) => {
        setLoader(true)
        let updateData = {
            "Name": values.name,
            "Account_number": values.accountNo.toString(),
            "Account_type": values.accType,
            "Bank_Name": mandateData?.Bank_Name ? mandateData?.Bank_Name : bankName,
            "Branch_Code": values.ifscCode,
            "Phone": values.mobileNo.toString(),
            "Loan_Amount": mandateData?.Loan_Amount,
            "Email": values.email,
            "Frequency": mandateData?.Frequency,
            "Mandate_type": mandateIdType,
            "Collection_Amount": mandateData?.Collection_Amount,
            "First_Collection_Date": mandateData?.First_Collection_Date,
            "Last_Collection_Date": mandateData?.Last_Collection_Date,
            "Source_Sys": mandateData?.Source_Sys,
            "lead_id": mandateData?.lead_id,
            "redirect_url": mandateData?.redirect_url,
            "callback_url": mandateData?.callback_url,
            "unique_id": mandateID ? mandateID : mandateData?.unique_id,
            "channel": formik?.values?.mandateOption
        }
        let config = {
            method: 'post',
            url: process.env.REACT_APP_UPI_API,
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: updateData
        };

        if (mandateData?.lead_id && mandateData?.Source_Sys && mandateIdType) {
            axios.request(config)
                .then((response) => {
                    setLoader(false)
                    // if(mandateData?.Source_Sys === "telecalling"){
                    //     navigate("/success")
                    // }
                    if (response?.data?.Status === "Failure") {
                        // enqueueSnackbar(response?.data?.Message, {
                        //     variant: "error",
                        //     preventDuplicate: true,
                        //     autoHideDuration: 3000,
                        // });
                        setShowErr(response?.data?.Message)
                    }
                    if (mandateIdType === 'digio-e-mandate' || mandateIdType === 'digio-upi-mandate') {
                        dispatch(setMessage(true))
                        setLoader(true)
                        seteNachRequestdata(response?.data?.response)
                    }
                    if (mandateIdType === 'web-p-mandate') {
                        setLoader(false)
                        dispatch(setBase64Data(response?.data?.PDFBase64))
                    }// 2. In the .then() handler, replace the broken return with setState
                    if (mandateIdType === 'hdfc-e-mandate' && response?.data?.URL) {
                        setLoader(false)
                        setHdfcHtmlString(response.data.URL)  // ✅ triggers re-render
                        return  // stop processing
                    }
                    else if (response.data.URL) {
                        dispatch(setMessage(true))
                        setDisable(true)
                        window.location.assign(response.data.URL)
                    }
                    else {
                        // enqueueSnackbar(response?.data?.Message, {
                        //     variant: "error",
                        //     preventDuplicate: true,
                        //     autoHideDuration: 3000,
                        // });
                        setLoader(false)
                        setShowErr(response?.data?.Message)
                    }
                })
                .catch((e) => {
                    setLoader(false)
                    setShowErr(e?.message)
                });
        }
        else {
            // enqueueSnackbar("Error! please try after some times", {
            //     variant: "warning",
            //     preventDuplicate: true,
            //     autoHideDuration: 3000,
            // });
            setShowErr("Error! please try after some times")
        }

    }

    const logout = () => {
        dispatch(setOtpTriggered(false))
        dispatch(setLoggedIn(false))
        navigate('/login')
    }
    const handleSubmit = event => {
        event.preventDefault();
        formik.handleSubmit()
    };
    useEffect(() => {
        if (Object.keys(mandateData).length === 0) {
            navigate('/payment')
        }
    }, [mandateData])
    return (
        <>
            {loader && <Loader />}
            {hdfcHtmlString && <HdfcRedirector htmlString={hdfcHtmlString} />}
            <form onSubmit={handleSubmit}>
                <div class="container in-spacer">
                    {!base64Data &&
                        <>
                            <div class="row">
                                <div class="col-12 ps-4 pe-4">
                                    <div class="Bcrumb">
                                        <a className="nav-link"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => window.history.go(-1)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    window.history.go(-1);
                                                }
                                            }}>
                                            <img class="lh-1" src={kotakImg} />
                                        </a>
                                        <span class="Mandate-text"><img className="me-2 face" src={mandateIdType === 'web-e-mandate' && Kotak || mandateIdType === 'web-a-mandate' && Kotak || mandateIdType === 'digio-e-mandate' && Digio || mandateIdType === 'digio-upi-mandate' && Digio || mandateIdType === 'hdfc-e-mandate' && HDFC} />  {mandateIdType === 'web-e-mandate' && 'E' || mandateIdType === 'web-a-mandate' && 'Aadhaar' || mandateIdType === 'digio-upi-mandate' && 'UPI' || mandateIdType === 'digio-e-mandate' && 'E' || mandateIdType === 'hdfc-e-mandate' && "E"} Mandate </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="number" className={"form-control " + ((formik.errors.accountNo && formik.touched.accountNo) ? "is-invalid" : "")} id="floatingInput1" name="accountNo" onChange={formik.handleChange} value={formik.values.accountNo} onBlur={formik.handleBlur} readOnly={mandateData?.Account_number} placeholder=" Enter Account No" />
                                            <label for="floatingInput">Account No</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.accountNo && formik.touched.accountNo
                                                    ? formik.errors.accountNo
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="text" className={"form-control " + ((formik.errors.name && formik.touched.name) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput1" name="name" onChange={formik.handleChange} value={formik.values.name} readOnly={mandateData?.Name} placeholder="Enter Name" />
                                            <label for="floatingInput">Account Holder Name</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.name && formik.touched.name
                                                    ? formik.errors.name
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="email" className={"form-control " + ((formik.errors.email && formik.touched.email) ? "is-invalid" : "")} id="floatingInput4" name="email" readOnly={mandateData?.Email} onChange={formik.handleChange} value={formik.values.email} placeholder="Email" />
                                            <label for="floatingInput">Email</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.email && formik.touched.email
                                                    ? formik.errors.email
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <select className={"form-select " + ((formik.errors.accType && formik.touched.accType) ? "is-invalid" : "")} onBlur={formik.handleBlur} name="accType" disabled={mandateData?.Account_type} onChange={formik.handleChange} value={formik.values?.accType}>
                                                <option key="0" value="">Choose...</option>
                                                <option key="1" value="current">Current Account</option>
                                                <option key="2" value="savings">Savings Account</option>
                                                <option key="3" value="Other">Other Account</option>
                                            </select>
                                            <label for="floatingInput">Account Type</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.accType && formik.touched.accType
                                                    ? formik.errors.accType
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="text" className={"form-control " + ((formik.errors.ifscCode && formik.touched.ifscCode) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput2" name="ifscCode" onChange={formik.handleChange} value={formik.values.ifscCode} placeholder="IFSC" readOnly={mandateData?.Branch_Code} />
                                            <label for="floatingInput">IFSC Code</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.ifscCode && formik.touched.ifscCode
                                                    ? formik.errors.ifscCode
                                                    : ''}
                                            </div>
                                            {!formik.values.ifscCode &&
                                                <div className="d-flex justify-content-end align-items-center mt-1">
                                                    <a
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => setisOpen(true)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                setisOpen(true)
                                                            }
                                                        }}
                                                        style={{ color: "#0000EE", textDecoration: "none", cursor: "pointer" }}
                                                    >
                                                        Find IFSC Code by Bank / Branch
                                                    </a>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-2">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="number" className={"form-control " + ((formik.errors.mobileNo && formik.touched.mobileNo) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput3" name="mobileNo" onChange={formik.handleChange} value={formik.values.mobileNo} readOnly={mandateData?.Phone} placeholder="Enter Phone No" />
                                            <label for="floatingInput">Phone No.</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.mobileNo && formik.touched.mobileNo
                                                    ? formik.errors.mobileNo
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-2">
                                    <div className='has-icon'>
                                        <div className="UPI-form">
                                            <div className="form-floating mb-3">
                                                <input type="number" className={"form-control " + ((formik.errors.amount && formik.touched.amount) ? "is-invalid" : "")} id="floatingInput5" name="amount" readOnly={mandateData?.Collection_Amount} onChange={formik.handleChange} value={formik.values.amount} placeholder=" Enter Amount" />
                                                <label for="floatingInput">Amount</label>
                                                <div className="invalid-feedback">
                                                    {formik.errors.amount && formik.touched.amount
                                                        ? formik.errors.amount
                                                        : ''}
                                                </div>
                                                <img src={Ruppee} /> </div>
                                        </div>
                                    </div>
                                    {showErr &&
                                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                            <p class="mb-1">{showErr}</p>
                                            <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                                        </div>
                                    }
                                </div>

                                {mandateIdType === "hdfc-e-mandate" && (
                                    <>
                                        <div className="col-12 mb-3">
                                            {/* Label on its own line above */}
                                            <label className="form-label d-block mb-2 fw-bold">Select Registration Method:</label>

                                            {/* The Row: Containing ONLY the 3 radio choices side-by-side */}
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="d-flex flex-row align-items-center gap-4 flex-wrap">

                                                        <div className="form-check">
                                                            <input
                                                                className={"form-check-input " + ((formik.errors.mandateOption && formik.touched.mandateOption) ? "is-invalid" : "")}
                                                                type="radio"
                                                                name="mandateOption"
                                                                id="debitCard"
                                                                value="Debit"
                                                                checked={formik?.values?.mandateOption === "Debit"}
                                                                onChange={formik?.handleChange}
                                                                disabled={disable}
                                                            />
                                                            <label className="form-check-label text-nowrap" htmlFor="debitCard">
                                                                Debit Card
                                                            </label>
                                                        </div>

                                                        <div className="form-check">
                                                            <input
                                                                className={"form-check-input " + ((formik.errors.mandateOption && formik.touched.mandateOption) ? "is-invalid" : "")}
                                                                type="radio"
                                                                name="mandateOption"
                                                                id="aadhaarCard"
                                                                value="Aadhar"
                                                                checked={formik?.values?.mandateOption === "Aadhar"}
                                                                onChange={formik?.handleChange}
                                                                disabled={disable}
                                                            />
                                                            <label className="form-check-label text-nowrap" htmlFor="aadhaarCard">
                                                                Aadhaar Card
                                                            </label>
                                                        </div>

                                                        <div className="form-check">
                                                            <input
                                                                className={"form-check-input " + ((formik.errors.mandateOption && formik.touched.mandateOption) ? "is-invalid" : "")}
                                                                type="radio"
                                                                name="mandateOption"
                                                                id="netBanking"
                                                                value="Net"
                                                                checked={formik?.values?.mandateOption === "Net"}
                                                                onChange={formik?.handleChange}
                                                                disabled={disable}
                                                            />
                                                            <label className="form-check-label text-nowrap" htmlFor="netBanking">
                                                                Net Banking
                                                            </label>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            {/* Formik Error Message on its own line below */}
                                            {formik.errors.mandateOption && formik.touched.mandateOption && (
                                                <div className="text-danger small mt-1 d-block">
                                                    {formik.errors.mandateOption}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div className="col-lg-4 col-sm-6">
                                            <button className="btn Proceed_btn w-100" disabled={disable} type="button submit">Register</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>}
                    {base64Data &&
                        <div class="row">
                            <div class="col-lg-6 col-sm-9 col-12">
                                <div class="text-center mb-5">
                                    <p class="fw-medium fs-6 mb-3">The PDF has been generated</p>
                                    <button class="btn DloadBtn" type='button' onClick={() => { downloadPdf() }}>
                                        <img src={download} />
                                        <div class="details">
                                            <p>Download</p>
                                            <span>the generated PDF</span>
                                        </div>
                                    </button>
                                </div>
                                <div>
                                    <div class="dropzone mb-3">
                                        <div class="dropzone-msg" {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
                                            <div class="mb-2">
                                                <img src={upload} />
                                            </div>
                                            <h3 class="dropzone-msg-title">Drag &amp; Drop or <a href="#">Choose file</a> to Upload</h3>
                                            <span class="dropzone-msg-desc">Please sign and upload the Image</span>
                                        </div>
                                    </div>
                                    {dmsId && <div class="Up-List">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex gap-2">
                                                <img src={pdf} />
                                                <div class="detail">
                                                    <p>File-name.pdf</p>
                                                    <span>19 MB</span>
                                                </div>
                                            </div>
                                            <div>
                                                <img src={close} />
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-10">
                                                <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="50" aria-valuemin="0"
                                                    aria-valuemax="100">
                                                    <div class="progress-bar" style={{ width: "50%" }}></div>
                                                </div>
                                            </div>
                                            <div class="col-2 lh-1 text-secondary text-end">
                                                50%
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                {/* <div class="col-lg-6 col-12 mt-4">
                            <button class="btn Proceed_btn w-100" onclick="window.location.href='';">Save</button>
                          </div> */}
                            </div>
                        </div>}
                    <div class="row">
                        <div class="col-12">
                            <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                                <div class="container">
                                    <a class="navbar-brand-sm" href="#">
                                        <img src={cholaLogo} alt="Chola Logo" />
                                    </a>
                                    <ul class="nav-list">
                                        <li class="nav-item">
                                            {/* <a class="nav-link" href="Language.html">
                                                <img src={Lang} />
                                            </a> */}
                                        </li>
                                        {partner === 'chola-web' && <li>
                                            <a href="#" onClick={logout}>Logout</a>
                                        </li>}
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                    {isOpen && (
                        <Modal open={isOpen} aria-labelledby="modal-title">
                            <Grow in={true} style={{ transformOrigin: "center" }} timeout={500}>
                                <div
                                    className="modal fade show"
                                    id="Terms"
                                    style={{ display: "block" }}
                                    aria-modal={true}
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                        <div className="modal-content" style={{ height: "100vh" }}>
                                            <div
                                                className="modal-header"
                                                style={{ paddingRight: "15px", paddingLeft: "15px" }}
                                            >
                                                <h1 className="modal-title fs-5" id="TermsLabel">
                                                    Search IFSC
                                                </h1>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => {
                                                        setisOpen(false);
                                                        setFilteredResult(null);
                                                        setBankName("");
                                                        setBranchorcityName("");
                                                    }}
                                                />
                                            </div>
                                            <div className="modal-body" style={{ padding: "0 15px" }}>
                                                <div className="col-md-12 mb-3">
                                                    <label className="form-label">Bank Name</label>
                                                    <div className="custom-dropdown">
                                                        <Select
                                                            placeholder="Search Bank"
                                                            onChange={handleChangeBank}
                                                            getOptionLabel={(option) => {
                                                                return option.name;
                                                            }}
                                                            // onKeyDown={validateAlpha}
                                                            getOptionValue={(option) => {
                                                                return option.value;
                                                            }}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            options={options}
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderRadius: "8px",
                                                                    fontSize: "14px",
                                                                    paddingTop: "5px",
                                                                    paddingBottom: "5px",
                                                                }),
                                                            }}
                                                        // styles={customStyles}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <label className="form-label">Branch / City Name</label>
                                                    <div className="custom-dropdown">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Branch/City"
                                                            // name="bankAccountName"
                                                            value={branchorcityName}
                                                            onChange={(e) => setBranchorcityName(e.target.value)}
                                                        // onBlur={handleBlur}
                                                        // onKeyDown={validateAlpha}
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={serachIfscData}
                                                    disabled={!bankName || !branchorcityName || loading}
                                                    className="btn btn-primary w-100"
                                                    type="button"
                                                >
                                                    Find {""} {loading && <CircularProgress size={17} />}
                                                </button>
                                                <br />
                                                <br />
                                                <div className="">
                                                    {Array.isArray(filteredResult) &&
                                                        (filteredResult.length > 0 ? (
                                                            filteredResult?.map((item) => {
                                                                return (
                                                                    <>
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div className="d-flex flex-column">
                                                                                <span>{item.ifsc_code}</span>
                                                                                <span>
                                                                                    {item.bank_name} - {item.branch_name}
                                                                                </span>
                                                                            </div>
                                                                            <a
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() =>
                                                                                    onSelectingIFSC(item.ifsc_code)
                                                                                }
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                        e.preventDefault();
                                                                                        onSelectingIFSC(item.ifsc_code)
                                                                                    }
                                                                                }}
                                                                                style={{ textDecoration: "none" }}
                                                                            >
                                                                                Select
                                                                            </a>
                                                                        </div>
                                                                        <hr
                                                                            style={{ margin: "2.5px 0", height: ".5px" }}
                                                                        />
                                                                    </>
                                                                );
                                                            })
                                                        ) : (
                                                            <p className="text-danger text-center">
                                                                No Data Found
                                                            </p>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Grow>
                        </Modal>
                    )}
                    {eNachRequestdata && !eNachResponsedata && (
                        <Digimandate
                            lead_id={mandateData?.lead_id}
                            Mid={eNachRequestdata?.id}
                            identifier={eNachRequestdata?.mobile}
                            gwt={eNachRequestdata?.access_token?.id}
                            setReqData={seteNachRequestdata}
                        />
                    )}
                </div>
            </form>
        </>
    )
}

export default Kotakmandate